import Hero from '../Home/Hero';

const Home = () => {
  return (
    <>
      <Hero />
    </>
  );
};

export default Home;
